<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>
                Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllConsignment('printAllConsignment')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="customerShopName"
                label="Customer Shop Name"
                type="text"
                v-model="queryParams.customerShopName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-text-field
                name="marketerName"
                label="Marketer Name"
                type="text"
                v-model="queryParams.marketerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="statusList"
                label="Choose Stock In Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="regionList"
                label="Choose Region ..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                v-model="queryParams.regionId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="consignmentList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.issueNo }}</td>
                <td>{{ props.item.consignedDateInMilliSeconds | format-ms-date}}</td>
                <td>{{ props.item.customerShopName }}</td>
                <td>{{ props.item.regionName }}</td>
                <td>{{ props.item.currencyName }}</td>
                <td style="text-align: right">{{ props.item.totalAmount | decFormat(6)}}</td>
                <td style="text-align: right">{{ props.item.commission | decFormat(6)}}</td>
                <td style="text-align: right">{{ props.item.taxAmount | decFormat(6)}}</td>
                <td style="text-align: right">{{ props.item.netAmount | decFormat(6)}}</td>
                <td>{{ props.item.consignedBy }}</td>
                <td>{{ props.item.finishedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>
                  <div>
                    <v-btn
                      color="primary"
                      @click.stop="reprintConsignmentConsignInvoice(props.item.id)"
                    >CONSIGN</v-btn>
                  </div>
                </td>
                <td>
                  <v-btn
                    :disabled="props.item.status == 'CONSIGN'"
                    color="primary"
                    @click.stop="reprintConsignmentInvoice(props.item.id)"
                  >INVOICE</v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.consignmentItems"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.productName }}</td>
                      <td class="text-xs">{{ subprops.item.factorUnitName }}</td>
                      <td class="text-xs">{{ subprops.item.consignQty | decFormat(6) }}</td>
                      <td class="text-xs">{{ subprops.item.saleQty | decFormat(6) }}</td>
                      <td class="text-xs">{{ subprops.item.defectQty | decFormat(6) }}</td>
                      <td class="text-xs">{{ subprops.item.returnQty | decFormat(6) }}</td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.sellingPrice | decFormat(6) }}</td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.saleQty * subprops.item.sellingPrice | decFormat(6) }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!--print all consignment -->
    <div id="printAllConsignment" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Consignment Report</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Issue No</th>
              <th style="text-align:left">Consigned Date</th>
              <th style="text-align:left">Customer Shop Name</th>
              <th style="text-align:left">Currency</th>
              <th style="text-align:left">Total Amount</th>
              <th style="text-align:left">Commision</th>
              <th style="text-align:left">Tax</th>
              <th style="text-align:left">Net Amount</th>
              <th style="text-align:left">Marketer Name</th>
              <th style="text-align:left">Finished Date</th>
              <th style="text-align:left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allConsignmentList" :key="index">
              <td>{{ item.issueNo }}</td>
              <td>{{ item.consignedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ item.customerShopName }}</td>
              <td>{{ item.currencyName }}</td>
              <td style="text-align: right">{{ item.totalAmount | decFormat(6)}}</td>
              <td style="text-align: right">{{ item.commision | decFormat(6)}}</td>
              <td style="text-align: right">{{ item.taxAmount | decFormat(6)}}</td>
              <td style="text-align: right">{{ item.netAmount | decFormat(6)}}</td>
              <td>{{ item.consignedBy }}</td>
              <td>{{ item.finishedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { consignmentService } from "../../services/consignment-service";
import { commonService } from "../../services/common-service";
import { regionService } from "../../services/region-service";

export default {
  name: "ConsignmentList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "General Reports",
        disabled: true
      },
      {
        text: "Consignment Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Status", value: "status" },
      { text: "Issue No", value: "issueNo" },
      { text: "Consigned Date", value: "consignedDate" },
      { text: "Customer Shop Name", value: "customerShopName" },
      { text: "Region", value: "regionName" },
      { text: "Currency", value: "currencyName" },
      { text: "TotalAmount", value: "totalAmount", sortable: false },
      { text: "Commision", value: "commision", sortable: false },
      { text: "Tax", value: "tax", sortable: false },
      { text: "Net Amount ", value: "netAmount", sortable: false },
      { text: "Marketer Name", value: "marketerName" },
      { text: "Finished Date", value: "finishedDate" },
      { text: "Consign", align: "center", sortable: false },
      { text: "Invoice", align: "center", sortable: false }
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "Factor Unit", sortable: false },
      { text: "Consign Qty", sortable: false },
      { text: "Sale Qty", sortable: false },
      { text: "Defect Qty", sortable: false },
      { text: "Return Qty", sortable: false },
      { text: "Price", sortable: false },
      { text: "Sale Amount", sortable: false }
    ],
    decimalFormat: "",
    rowsPerPageItems: [20, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "finishedDate",
      totalItems: 0
    },
    statusList: [
      { label: "---All---", value: "" },
      { label: "CONSIGN", value: "CONSIGN" },
      { label: "FINISH", value: "FINISH" }
    ],
    consignmentList: [],
    allConsignmentList: [],
    regionList: [],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerShopName: "",
      marketerName: "",
      status: "",
      regionId: "",
      issueNo: ""
    },
    clonequeryParams: new Object(),
    printAllButtonLoading: false,
    totalRows: 0
  }),
  watch: {
    pagination: {
      handler() {
        this.getConsignmentList();
      },
      deep: true
    }
  },
  created() {
    this.decimalFormat = commonService.formatdecimal();
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.customerShopName) {
      this.queryParams.customerShopName = this.$route.query.customerShopName;
    }
    if (this.$route.query.issueNO) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.regionId) {
      this.queryParams.regionId = this.$route.query.regionId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getRegionList();
    this.getConsignmentList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getConsignmentList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },

    getRegionList() {
      regionService
        .getAllRegions()
        .then(res => {
          this.regionList = res.data;
          let findAll = {
            id: "",
            name: "---No Region---"
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getConsignmentList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      consignmentService
        .getConsignmentList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.consignmentList = res.data.consignmentList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAllConsignment(divName) {
      this.showListLoading = true;
      this.printAllButtonLoading = true;
      this.allConsignmentList = [];
      consignmentService
        .getAllConsignmentList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allConsignmentList = res.data.consignmentList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
          this.printAllButtonLoading = false;
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
          }, 600);
        });
    },
    reprintConsignmentInvoice(id) {
      consignmentService.printConsignmentInvoice(id).then(res => {
        var blob = res;
        consignmentService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    reprintConsignmentConsignInvoice(id) {
      consignmentService.printConsignmentConsignInvoice(id).then(res => {
        var blob = res;
        consignmentService.showWindowDialog(blob, "consign-invoice-" + id);
      });
    }
  }
};
</script>